import { c as o } from "./createLucideIcon-D4r5Phnh.js";
const r = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], t = o("arrow-down", r);
const a = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], c = o("arrow-up", a);
export {
  c as A,
  t as a
};
